import "./style.css";
import Loader from "react-js-loader";
function ButtonLoader(props) {
  const { type = "spinner-cub", bgColor, color, size = 30, ...rest } = props;
  //remove firsr class for background
  return (
    <div className="loader-button-container">
      <Loader
        type={type}
        bgColor={bgColor}
        color={color}
        // title={"spinner-cub"}
        size={size}
        {...rest}
      />
    </div>
  );
}

export default ButtonLoader;
